var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        { staticClass: "container_box" },
        [
          _c("pages-header", {
            ref: "pageHeader",
            attrs: {
              title: _vm.isViewMode
                ? "查看店铺分组"
                : _vm.isEdit
                ? "编辑店铺分组"
                : "添加店铺分组",
              backUrl: _vm.backPath,
            },
          }),
          _c(
            "el-card",
            {
              staticClass: "mt14",
              attrs: {
                "body-style": { padding: "0 20px 20px" },
                shadow: "never",
                bordered: false,
              },
            },
            [
              _vm.tabList.length > 0
                ? _c(
                    "el-tabs",
                    {
                      staticClass: "list-tabs mb5",
                      model: {
                        value: _vm.currentTab,
                        callback: function ($$v) {
                          _vm.currentTab = $$v
                        },
                        expression: "currentTab",
                      },
                    },
                    _vm._l(_vm.tabList, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: { name: item.value, label: item.title },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "formValidate",
                  staticClass: "formValidate",
                  attrs: {
                    rules: _vm.ruleValidate,
                    model: _vm.formValidate,
                    "label-width": "120px",
                    autocomplete: "off",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "1",
                          expression: "currentTab === '1'",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "父级：", prop: "pid" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "420px" },
                              attrs: {
                                placeholder: "请选择父级",
                                disabled: _vm.areaFormDisabled || _vm.isEdit,
                              },
                              model: {
                                value: _vm.formValidate.pid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "pid", $$v)
                                },
                                expression: "formValidate.pid",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "顶级", value: 0 },
                              }),
                              _vm._l(_vm.parentAreas, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.name,
                                    value: item.id,
                                    disabled: item.disabled,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺分组名称：", prop: "name" } },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "420px",
                              "margin-right": "32px",
                            },
                            attrs: {
                              placeholder: "请填写店铺分组名称",
                              disabled: _vm.areaFormDisabled,
                            },
                            model: {
                              value: _vm.formValidate.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "name", $$v)
                              },
                              expression: "formValidate.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "店铺数量：" } }, [
                        _c("span", { staticClass: "merchant-count-text" }, [
                          _vm._v(_vm._s(_vm.currentMerchantCount)),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "区域开关：", prop: "addressSwitch" },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              disabled: _vm.areaFormDisabled,
                              "active-value": 1,
                              "inactive-value": 2,
                              "active-text": "开启",
                              "inactive-text": "关闭",
                            },
                            model: {
                              value: _vm.formValidate.addressSwitch,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "addressSwitch", $$v)
                              },
                              expression: "formValidate.addressSwitch",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.formValidate.addressSwitch === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "店铺分组代理中心：",
                                prop: "address",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "location-picker" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "location-summary" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "location-summary__main",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "location-summary__label",
                                            },
                                            [_vm._v("当前选点")]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "location-summary__address",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formValidate.address ||
                                                    "请在地图中搜索或点击选择位置"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.formValidate.latitude &&
                                      _vm.formValidate.longitude
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "location-summary__coord",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formValidate.latitude
                                                  ) +
                                                  ", " +
                                                  _vm._s(
                                                    _vm.formValidate.longitude
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formValidate.latitude,
                                        expression: "formValidate.latitude",
                                      },
                                    ],
                                    attrs: { type: "hidden" },
                                    domProps: {
                                      value: _vm.formValidate.latitude,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formValidate,
                                          "latitude",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formValidate.longitude,
                                        expression: "formValidate.longitude",
                                      },
                                    ],
                                    attrs: { type: "hidden" },
                                    domProps: {
                                      value: _vm.formValidate.longitude,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.formValidate,
                                          "longitude",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  !_vm.areaFormDisabled &&
                                  _vm.currentTab === "1"
                                    ? _c("tencent-map", {
                                        ref: "tencentMap",
                                        attrs: {
                                          layout: "pc",
                                          "map-height": "520px",
                                          center: _vm.mapCenter,
                                          value: _vm.mapLocation,
                                          zoom: 14,
                                          tips: "可搜索地址、点击地图或拖拽标记点选择店铺分组代理中心",
                                        },
                                        on: {
                                          "location-change":
                                            _vm.onLocationChange,
                                          "map-ready": _vm.onMapReady,
                                          "map-error": _vm.onMapError,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "2",
                          expression: "currentTab === '2'",
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "merchant-section" }, [
                        _c(
                          "div",
                          { staticClass: "merchant-header" },
                          [
                            !_vm.isViewMode && _vm.canBindCircleMerchant()
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "debounceClick",
                                        rawName: "v-debounceClick",
                                        value: _vm.openMerchantDialog,
                                        expression: "openMerchantDialog",
                                      },
                                    ],
                                    attrs: { type: "primary" },
                                  },
                                  [_vm._v("选择店铺")]
                                )
                              : _vm._e(),
                            _vm.formValidate.merchantList &&
                            _vm.formValidate.merchantList.length > 0
                              ? _c("span", { staticClass: "merchant-count" }, [
                                  _vm._v(
                                    " 共 " +
                                      _vm._s(_vm.currentMerchantCount) +
                                      " 个店铺 "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "merchant-table-container" },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.getTableData(),
                                  border: "",
                                  "empty-text": "",
                                  "row-key": _vm.getMerchantUniqueId,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "id",
                                    label: "ID",
                                    width: "80",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "name",
                                    label: "店铺名称",
                                    "min-width": "150",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "realName",
                                    label: "联系人",
                                    width: "120",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "phone",
                                    label: "联系方式",
                                    width: "140",
                                  },
                                }),
                                !_vm.isViewMode && _vm.canBindCircleMerchant()
                                  ? _c("el-table-column", {
                                      attrs: { label: "操作", width: "100" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleRemoveMerchant(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 删除 ")]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        273598349
                                      ),
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              !_vm.isViewMode &&
              (_vm.canSaveAreaInfo() || _vm.canBindCircleMerchant())
                ? _c(
                    "div",
                    { staticClass: "form-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentTab === "1",
                              expression: "currentTab === '1'",
                            },
                          ],
                          staticClass: "priamry_border",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.currentTab = "2"
                            },
                          },
                        },
                        [_vm._v("下一步")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentTab === "2",
                              expression: "currentTab === '2'",
                            },
                          ],
                          staticClass: "priamry_border",
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.currentTab = "1"
                            },
                          },
                        },
                        [_vm._v("上一步")]
                      ),
                      _vm.canSaveAreaInfo()
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentTab === "1",
                                  expression: "currentTab === '1'",
                                },
                                {
                                  name: "debounceClick",
                                  rawName: "v-debounceClick",
                                  value: _vm.saveArea,
                                  expression: "saveArea",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                size: "small",
                                loading: _vm.loading,
                              },
                            },
                            [_vm._v(_vm._s(_vm.isEdit ? "更新" : "确认"))]
                          )
                        : _vm._e(),
                      _vm.canBindCircleMerchant()
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentTab === "2",
                                  expression: "currentTab === '2'",
                                },
                                {
                                  name: "debounceClick",
                                  rawName: "v-debounceClick",
                                  value: _vm.saveMerchants,
                                  expression: "saveMerchants",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                size: "small",
                                loading: _vm.loading,
                              },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择店铺",
            visible: _vm.merchantDialogVisible,
            width: "720px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.merchantDialogVisible = $event
            },
            closed: _vm.resetMerchantDialogSelection,
          },
        },
        [
          _c(
            "div",
            { staticClass: "merchant-dialog-content" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.merchantForm, "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择店铺" } },
                    [
                      _c("mer-user-category-for-area", {
                        ref: "merchantSelector",
                        attrs: {
                          multiple: true,
                          "mer-id-checked": _vm.merchantForm.selectedMerchantId,
                          "disabled-ids": _vm.linkedMerchantIds,
                        },
                        on: { getMerId: _vm.getMerId },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeMerchantDialog } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "debounceClick",
                      rawName: "v-debounceClick",
                      value: _vm.confirmMerchantSelection,
                      expression: "confirmMerchantSelection",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.bindingMerchant },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }